export const getLookupData = table => ({
  type: 'LOOKUP_DATA_REQUESTED'
})

export const getLookupDataSuccess: any = () => ({
  type: 'LOOKUP_DATA_SUCCESS'
})

export const getLookupDataError: any = data => ({
  type: 'LOOKUP_DATA_FAILED',
  payload: data
})

export const getLookupTableData = table => ({
  type: `GET_${table}_REQUESTED`
})

export const getLookupTableDataSuccess: any = ({ table, data }) => ({
  type: `GET_${table}_SUCCESS`,
  payload: data
})

export const getLookupTableDataError: any = ({ table, data }) => ({
  type: `GET_${table}_ERROR`,
  payload: data
})
